import { render } from "./factures.vue?vue&type=template&id=05c5325d&scoped=true"
import script from "./factures.vue?vue&type=script&lang=js"
export * from "./factures.vue?vue&type=script&lang=js"

import "./factures.vue?vue&type=style&index=0&id=05c5325d&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c5325d"]])

export default __exports__